import { connect } from 'react-redux';

import IntelligentReview from './IntelligentReview.js';
import { redux } from '../api';

const { setApplicationInfo, setCurrentSearchInfo } = redux.actions;

const mapStateToProps = state => {
  return {
    userInfo: state.api.user.info,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setApplicationData: data => dispatch(setApplicationInfo(data)),
    setCurrentSearchInfoData: data => dispatch(setCurrentSearchInfo(data)),
  };
};

const ConnectedIntelligentReview = connect(
  mapStateToProps,
  mapDispatchToProps
)(IntelligentReview);

export default ConnectedIntelligentReview;
